<template>
    <div class="mian">
        <div class="invite">
            <img class="invite_img" src="@/assets/images/parent_active/invite/invite_earnings.png"/>
            <div class="invite_data">
                <img class="data_img" src="@/assets/images/parent_active/invite/invite_redbox.png"/>
                <countTo class="person_num" :startVal='old_inviteNum' :endVal='parseInt(inviteData.inviteNum)' :duration='2000' separator=""></countTo>
                <countTo class="cur_num" :startVal='old_coinNum' :endVal='parseInt(inviteData.coinNum)' :duration='2000'  separator=""></countTo>
                <countTo class="estimate_num" :startVal='old_expectCoinNum' :endVal='parseInt(inviteData.expectCoinNum)' :duration='2000'  separator=""></countTo>
            </div>
            <div class="invite_progress" v-for="(item, idx) in inviteData.inviteList" :key="idx" :data-star="item.coin">
                <div class="nick">用户昵称：{{item.userName}}</div>
                <van-progress pivot-text="" 
                    stroke-width="10" 
                    color="#EE8D46" 
                    track-color="#F6DDB4"
                    :percentage="getPercentage(item.coin)" />
                <div class="num_content">
                    <span class="num_min">0</span>
                    <span class="num_cur" :style="getStyleLeft(item.coin)" v-show="item.coin < 1000">{{item.coin}}</span>
                    <span class="num_max">1000</span>
                </div>
            </div>
            
        </div>
        <img class="get" src="@/assets/images/parent_active/invite/invite_parent_getmore.png"/>
        <div class="exchange-con">
            <img class="exchange"  src="@/assets/images/parent_active/invite/invite_parent_exchange.png"/>
            <div class="feedback" @click="feedback()">
                <span class="text">反馈问题</span>
                <img class="img" src="@/assets/images/parent_active/invite/invite_parent_feedback.png"/>
            </div>
            <div class="item-bg">
                <div class="item-content">
                    <div class="item" v-for="(item, idx) in inviteData.productList" :key="idx" @click="jumpDesc(item.jumpUrl)">
                        <img class="img" :src="item.coverImg"/>
                        <div class="title">{{item.title}}</div>
                        <div class="desc">{{item.desc}}</div>
                    </div>
                </div>
                <div class="showMore" @click="showMore()">更多商品</div>
            </div>
        </div> 
    </div>
</template>
<script>

import countTo from 'vue-count-to';
export default {
    components:{
        countTo,
    },
    props:{
        inviteData:{
            type: Object,
            default: ()=>{
                return ;
            }
        }
    },
    data(){
        return{
            old_inviteNum: "0",
            old_coinNum: "0",
            old_expectCoinNum: "0",
        }
    },
    created(){
        this.old_coinNum = window.localStorage.getItem("coinNum") != null ? parseInt(window.localStorage.getItem("coinNum")) : 0;
        console.log('coinNum',this.old_coinNum);
        this.old_inviteNum = window.localStorage.getItem("inviteNum") != null ? parseInt(window.localStorage.getItem("inviteNum")) : 0;
        this.old_expectCoinNum = window.localStorage.getItem("expectCoinNum") != null ? parseInt(window.localStorage.getItem("expectCoinNum")) : 0;
    },
    mounted(){
        window.localStorage.setItem("inviteNum", this.inviteData.inviteNum.toString());
        window.localStorage.setItem("coinNum", this.inviteData.coinNum.toString());
        window.localStorage.setItem("expectCoinNum", this.inviteData.expectCoinNum.toString());
    },
    
    methods:{
        feedback(){
            window.location.href = "hybird://method/openFeedback";
        },
        showMore(){
            window.location.href = this.inviteData.moreProductUrl;
        },
        jumpDesc(jumpUrl){
            window.location.href = "hybird://method/openNewWindow?url=" + encodeURIComponent(jumpUrl + '&hideTitleBar=false');
            console.log(jumpUrl + '&hideTitleBar=false')
        },
        getPercentage(num){
            return Math.floor(parseInt(num) / 10);
        },
        getStyleLeft(num){
            return `left:${Math.floor(parseInt(num) / 10)}%` ;
        },
    },

}
</script>
<style lang="scss" scoped>
.mian{
    position: absolute;
    top: 7.55rem;
    background-color: #fae2bf;
    .invite{
        margin: auto .22rem;
        text-align: center;
        width: 7rem;
        padding-bottom: 0.06rem;
        background: #FEF8ED;
        box-shadow: 0rem .02rem .04rem 0rem rgba(251, 218, 191, 0.54);
        border-radius: .2rem;
        .invite_img{
            width: 2.38rem;
            height: .58rem;
        }
        .invite_data{
            position: relative;
            margin: .22rem auto;
            .data_img{
                width: 6.77rem;
                height: 1.54rem;
            }
            @mixin data_num{
                position: absolute;
                font-size: .48rem;
                font-family: PingFang SC;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 0.65rem;
                top: 0.62rem;
                text-align: right;
            }
            .person_num{
                @include data_num;
                left: 0.77rem;
                width: 0.6rem;
            }
            .cur_num{
                @include data_num;
                left: 2.13rem;    
                width: 1.49rem;
            }
            .estimate_num{
                @include data_num;
                left: 4.57rem;
                width: 1.49rem;
            }
        }
        .invite_progress{
            text-align: left;
            margin: .21rem auto .45rem;
            width: 6.5rem;
            .nick{
                font-size: .24rem;
                font-family: PingFang SC;
                font-weight: 600;
                color: #A37426;
                line-height: .57rem;
            }
            .num_content{
                position: relative;
                width: 6.5rem;
                padding-top: .17rem
            }
            @mixin num{
                font-size: .24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #B77F28;
            }
            .num_min{
                @include num;
            }
            .num_cur{
                position: absolute;
                // left: 50%;
                transform: translateX(-50%);
                @include num;
            }
            .num_max{
                position: absolute;
                right: 0;
                @include num;
            }
        }
    }
    .get{
        margin: auto .22rem;
        margin-top: .55rem; 
        width: 7.07rem;
        height: 7.31rem;
    }
    .exchange-con{
        position: relative;
        margin: .55rem .22rem 1.35rem;
    }
    .exchange{
        width: 7.07rem;
        height: 8.79rem;
    }
    .feedback{
        position: absolute;
        right:.16rem;
        top: .13rem;
        display: flex;
        .text{
            font-size: .22rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #A37426;
            line-height: .31rem;
        }
        .img{
            margin-left: .08rem;
            width: .32rem;
            height: .32rem;
        }
    }
    .item-bg{
        position: absolute;
        left: .21rem;
        bottom: .32rem; 
        width: 6.64rem;
        height: 4.62rem;
        background: #FCDFB8;
        box-shadow: 0rem .02rem .05rem 0rem rgba(226, 166, 83, 0.42);
        border-radius: .2rem;
        .item-content{
            display: flex;
            justify-content: space-around;
        }
        .item{
            position: relative;
            margin-top: .39rem;
            background-color: #FFF0CE;
            width: 2.4rem;
            height: 3.16rem;
            border-radius: .2rem;
            align-items: center;
            img{
                width: 100%;
                height: 1.97rem;
                border-radius: .2rem .2rem 0 0;
            }
            .title{
                position: absolute;
                bottom: .6rem;
                left: 50%;
                transform: translateX(-50%);
                font-size: .24rem;
                font-family: PingFang SC;
                font-weight: 600;
                color: #A37426;
                line-height: .29rem;
                white-space: nowrap;
            }
            .desc{
                position: absolute;
                bottom: .2rem;
                left: 50%;
                transform: translateX(-50%);
                font-size: .24rem;
                font-family: PingFang SC;
                font-weight: 600;
                color: #E94B42;
                line-height: .29rem;
                white-space: nowrap;
            }
        }
        .showMore{
            margin: 0.34rem auto;
            width: 2.05rem;
            background: #FFF0DD;
            border: .01rem solid #B78844;
            border-radius: .24rem;
            font-size: .24rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #A37426;
            line-height: .48rem;
            text-align: center;
        }
    }
}
/deep/ .van-progress{
    ::after{
        content: '';
        background: url('../../../../assets/images/parent_active/invite/invite_progressbar.png') no-repeat center;//通过伪元素的背景添加图片路径 ，no-repeat->不重复 center->居中表示
        display: block;    //也可以是inline-bolck但是主要是block的特性才能设置宽高
        width: .42rem;    //kuan宽
        height: .42rem;    //高
        background-size: .42rem;//通过这个属性来设置图片的宽高
        display: block;
        top: -50%; 
        position: absolute;
        right: -0.21rem;
    }
}
/deep/ .van-progress__portion{
    background-image: linear-gradient(to right,#EE8D46, #E84D43) !important;
}   
</style>
